// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sdfCD","fullScreen":"styles_fullScreen__VqziA","ldsGrid":"styles_ldsGrid__xVR3d"};